import { gql } from "@apollo/client";

export const GET_STRIVE_BUCKETS = gql`
query striveBuckets($pageOptions: PageOptions) {
  striveBuckets(pageOptions: $pageOptions)
}
`

export const GET_STRIVE_BUCKETS_DETAILS = gql`
query striveBucketDetails($proposals: Int!, $listings: Int!, $status: String, $agentId: Int) {
  striveBucketDetails(PROPOSALS: $proposals, LISTINGS: $listings, STATUS: $status, AGENT_ID: $agentId) {
    data
    success
  }
}
`
export const GET_TEAM_DATA = gql`
query GetTeamMember($arcimedesRowId: ID!) {
  getTeamMember(arcimedes_row_id: $arcimedesRowId) {
    arcimedes_row_id
    first_name
    last_name
    title
    phone
    linkedin
    email
    description
    photo
    credentials
    is_agent
    deleted
    is_admin
    visible_on_website
    starting_date
    termination_date
    yrs_at_strive
    birth_date
    age
    on_phones
    in_pool
    first_listing
    first_closing
    address
    city
    state
    zip
    cell_phone
    territory
    w4_form
    w9_form
    payroll_form
    ca_form
    it_policy_form
    trade_secrets_form
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`;
